<template>
  <div class="mb-4">
    <div class="label">{{ label }}</div>
    <div
      class="filter-item pl-2 pr-2 mt-2 mb-2"
      v-for="(option, index) in options"
      :key="index"
      name="radios"
      @click="onClick(index)"
    >
      {{ option }}
    </div>
  </div>
</template>

<script>
export default {
  name: "TextFilter",
  props: {
    label: String,
    options: Object,
  },
  methods: {
    onClick(value) {
      this.$emit("onFitlerSelect", value);
    },
  },
};
</script>

<style scoped lang="scss">
.filter-item {
  background: $color-light;
  height: 44px;
  line-height: 44px;
  cursor: pointer;
  @include border-radius(0.25rem);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;

  &:hover {
    background: $color-blue-light;
  }
}

.label {
  font-weight: bold;
}
</style>
